import axios from 'axios'
import { URL } from '../../config'
import { getRequest } from '../../utils/httpRequest'
import { 
	FETCH_ACTIVE_SEASONS, FETCH_SEASON_DATES, SAVE_SEASON_DATES, SAVE_SEASON_OILCONDITIONS, 
	SAVE_SEASON_SETUP, SAVE_SEASON_PARTICIPANT,SAVE_SEASON_TEMPLATE , TRIGGER_SEASON,SAVE_SEASON_RANKINGPOINTS,
	RESET_DATES_SETTINGS,RESET_OIL_SETTINGS,RESET_SETUP_SETTINGS,RESET_PARTICIPANT_SETTINGS,
	RESET_TEMPLATE_SETTINGS,RESET_RANKING_POINTS_SETTINGS,SAVING_SEASON_RANKING,SET_RANKINGPOINTS_FILE,FETCH_SEASON_RANKING_POINTS,
	GETTING_SEASON_RANKING_POINTS
} from '.'

const seasonURL = URL.season

export function fetchSeasonRankingPoints(seasonId, tier) {
	const url = `${seasonURL}/rankingpoints/${seasonId}/${tier}`
	const request = getRequest(url)
	return {
		type: FETCH_SEASON_RANKING_POINTS,
		payload: request
	}
}
export function gettingSeasonRankingPoints(){
	return {
		type: GETTING_SEASON_RANKING_POINTS
	}
}
export function fetchActiveSeasons() { 
	const url = `${seasonURL}/active`
	const request = axios.get(url,
		{ 
			crossdomain: true,
			headers:{
					'Access-Control-Allow-Origin' : '*',
					'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
			}
		}
	)
	return {
		type: FETCH_ACTIVE_SEASONS,
		payload: request
	}
}
export function fetchSeasonDates(seasonId){
    const url = `${seasonURL}/${seasonId}/dates`
    const request = axios.get(url,
			{ 
				crossdomain: true,
				headers: {
					'Access-Control-Allow-Origin' : '*',
					'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
				}
			}
    )
    return {
        type: FETCH_SEASON_DATES,
        payload: request
    }
}
export function saveSeasonDates(seasonId,seasondates) {
    const url = `${seasonURL}/${seasonId}/dates`
    const request = axios.put(url,seasondates,
        { 
					crossdomain: true,
					headers:{
						'Access-Control-Allow-Origin' : '*',
						'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
					}
       }
    )
    return {
        type: SAVE_SEASON_DATES,
        payload: request
    }
}
export function triggerSeason(seasonId, season) {
    const url = `${seasonURL}/${seasonId}/trigger`
    
    
    const request = axios.put(url,season,
        { 
            crossdomain: true,
            headers:{
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
           }
       }
    )
    return {
        type: TRIGGER_SEASON,
        payload: request
    }
}
export function saveSeasonOilConditions(seasonId,seasonoilconditions){
        const url = `${seasonURL}/${seasonId}/oilconditions`
        const request = axios.put(url,seasonoilconditions,
            { 
                crossdomain: true,
                headers:{
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
               }
           }
        )
        return {
            type: SAVE_SEASON_OILCONDITIONS,
            payload: request
        }
}
export function saveSeasonSetup(seasonId,seasonsetup) {
    const url = `${seasonURL}/${seasonId}/setup`
    const request = axios.put(url,seasonsetup,
        { 
            crossdomain: true,
            headers:{
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
           }
       }
    )
    return {
        type: SAVE_SEASON_SETUP,
        payload: request
    }
}
export function saveSeasonParticipant(seasonId,seasonparticipant) {
    const url = `${seasonURL}/${seasonId}/participant`
    const request = axios.put(url,seasonparticipant,
        { 
            crossdomain: true,
            headers:{
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
           }
       }
    )
    return {
        type: SAVE_SEASON_PARTICIPANT,
        payload: request
    }
}
export function saveSeasonTemplate(seasonId,seasontemplate) {
    const url = `${seasonURL}/${seasonId}/template`
    const request = axios.put(url,seasontemplate,
        { 
            crossdomain: true,
            headers:{
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
           }
       }
    )
    return {
        type: SAVE_SEASON_TEMPLATE,
        payload: request
    }
}
export function saveSeasonRankingPoints(pointsFile) {
	const { season,tier } = pointsFile
	const url = `${seasonURL}/${season}/${tier}/uploadranking`
	const request = axios.post(url,pointsFile,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'content-type': 'multipart/form-data' 
			}
		}
	)
	return {
		type: SAVE_SEASON_RANKINGPOINTS,
		payload: request
	}
}
export function resetSetupSettings() {
	return {
		type: RESET_SETUP_SETTINGS
	}
}
export function resetDatesSettings() { 
	return {
		type: RESET_DATES_SETTINGS
	}
}
export function resetOilSettings() {
	return {
		type: RESET_OIL_SETTINGS
	}
}
export function resetParticipantSettings() {
  return {
		type: RESET_PARTICIPANT_SETTINGS
	}
}
export function resetTemplateSettings() {
  return {
		type: RESET_TEMPLATE_SETTINGS
	}
}
export function resetRankingPoints() {
	return {
		type: RESET_RANKING_POINTS_SETTINGS
	}
}
export function savingSeasonRankingPoints() {
	return {
		type:SAVING_SEASON_RANKING
	}
}
export function setRankingPointsFile(filename) {
	return {
		type:SET_RANKINGPOINTS_FILE,
		payload:filename
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/action_seasonsettings.js